import 'swiper/css'

import { Box, Stack } from '@chakra-ui/react'
import { FC } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import { H2 } from '../../typography'
import { SlideCard } from './SlideCard'

interface ImageLinkSliderSectionProps {
  header?: string
  data: {
    title?: string
    imageSrc: string
    href: string
  }[]
}

const ImageLinkSliderSection: FC<ImageLinkSliderSectionProps> = ({
  header = 'Consultas, medicação, cursos e especialistas em um só lugar',
  data
}) => {
  return (
    <Box bg="alabaster">
      <Stack pt={{ base: '24px', lg: '48px' }} pb="48px" gap={{ base: 10, lg: '72px' }} maxWidth="1310px" mx="auto">
        <H2 color="phthalo" w={{ base: '90%', lg: '50%' }} mx="auto" textAlign="center">
          {header}
        </H2>

        <Box px={{ base: 'none', lg: '64px' }}>
          <Swiper
            grabCursor={true}
            slidesPerView={1.35}
            slidesOffsetBefore={24}
            spaceBetween={20}
            slidesOffsetAfter={24}
            breakpoints={{
              620: {
                slidesPerView: 2.53,
                spaceBetween: 32,
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
                pagination: false
              },
              990: {
                slidesPerView: 3,
                spaceBetween: 24,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                pagination: false
              }
            }}
          >
            {data.map(({ title, href, imageSrc }, index) => (
              <SwiperSlide
                key={index}
                style={{
                  position: 'relative',
                  height: 'auto'
                }}
              >
                <SlideCard {...{ title, href, imageSrc }} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Stack>
    </Box>
  )
}

export default ImageLinkSliderSection
